import React, { createContext, useCallback, useRef, useState } from 'react'
import type { PrintContextType } from '../types/printable-pdf.type'
import { usePrintingContext } from '../hooks/usePrintingContext'
import { pdfDataToUrl } from '../../components/file/FileViewer/PdfViewerLegacy/pdf.utils'

export const PrintContext = createContext<PrintContextType>({
  printBlob: () => {},
  href: null,
})

export const PrintablePdfProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [href, setHref] = useState<string | null>(null)
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const { finishPrinting } = usePrintingContext()

  const handlePrint = useCallback(
    (delay: number) => {
      setTimeout(() => {
        iframeRef.current?.contentWindow?.focus()
        iframeRef.current?.contentWindow?.print()
        finishPrinting()
      }, delay)
    },
    [finishPrinting],
  )

  const calcPrintDelay = (size: number): number => {
    const kb = size / 1024
    const delay = kb * 10 // 10 ms per KB
    return Math.min(Math.max(Math.round(delay), 500), 2000) // max 2s
  }

  const printBlob = useCallback(
    (blob: Blob) => {
      // Revoke previous URL if any
      if (href) URL.revokeObjectURL(href)

      // Create a blob URL
      const url = pdfDataToUrl(blob)
      setHref(url)

      const delay = calcPrintDelay(blob.size)

      console.log({
        delay,
      })
      handlePrint(delay)
    },
    [handlePrint, href],
  )

  return (
    <PrintContext.Provider value={{ printBlob, href }}>
      {children}
      {href && (
        <iframe
          ref={iframeRef}
          id="printFrame"
          src={href}
          referrerPolicy="no-referrer-when-downgrade"
          allow="*"
          name="printFrame"
          title="printFrame"
          width="1"
          height="1"
          style={{ position: 'absolute', top: '-100px', display: 'none' }}
        />
      )}
    </PrintContext.Provider>
  )
}
